// extracted by mini-css-extract-plugin
module.exports = {"searchDiv":"styles_searchDiv__1JaxJ"};